var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row inline no-wrap q-pa-sm",class:`bg-${_vm.backgroundColor}`},[_c('QIcon',{staticClass:"q-mr-sm",attrs:{"name":_vm.icon,"color":_vm.iconColor,"size":"18px"}}),_c('span',{staticClass:"sai-tip-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }